import { useNavigate } from "react-router-dom";

function TermsConditions() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: "#000",
        color: "#fff",
        minHeight: "100vh",
        padding: "40px",
        fontFamily: "Arial, sans-serif",
        maxWidth: "1000px",
        margin: "0 auto",
      }}
    >
      <button onClick={() => navigate("/")} style={btn}>Back to Home</button>
      <h1>Terms and Conditions</h1>
      <p style={{ color: "#d1d1d1", lineHeight: "1.8" }}>
        By using MistriBazaar, you agree to provide accurate information, use the platform lawfully, and cooperate with service fulfillment processes.
      </p>
      <p style={{ color: "#d1d1d1", lineHeight: "1.8" }}>
        Worker assignment, pricing, and delivery timelines may vary depending on availability, location, and service demand.
      </p>
    </div>
  );
}
const btn = { marginBottom: "20px", padding: "10px 16px", border: "none", background: "black", color: "white", borderRadius: "8px", cursor: "pointer" };
export default TermsConditions;
